import { render, staticRenderFns } from "./senioriupUserList.vue?vue&type=template&id=93079e22&scoped=true&"
import script from "./senioriupUserList.vue?vue&type=script&lang=js&"
export * from "./senioriupUserList.vue?vue&type=script&lang=js&"
import style0 from "./senioriupUserList.vue?vue&type=style&index=0&id=93079e22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93079e22",
  null
  
)

export default component.exports